module.exports = __webpack_public_path__ + "img/framenew_box29.8e40e349.jpg";